import React from "react";
import DialogConfirmButtons from "../../common/dialogConfirmButtons/DialogConfirmButtons";
import SuccessMessage from "../../messages/SuccessMessage";

const EmailAccessVerifiedStep = ({ busy, user, onCompleted }) => {
  const onDoneClicked = () => {
    onCompleted();
  };

  const buttons = (
    <DialogConfirmButtons
      appearBusy={busy}
      confirmBtnEnabled={true}
      confirmBtnLabel="Done"
      onConfirm={onDoneClicked}
      omitCancelBtn={true}
    />
  );

  return (
    <div id="email-changed-step">
      <div className="verify-email-access-step-body">
        <SuccessMessage
          className="email-access-verified-success-message"
          message={`Verification of user's access to ${user?.email} has been confirmed.`}
        />
      </div>
      {buttons}
    </div>
  );
};

export default EmailAccessVerifiedStep;
